import { render, staticRenderFns } from "./SetupBusinessInfo.vue?vue&type=template&id=465911b0&scoped=true&"
import script from "./SetupBusinessInfo.vue?vue&type=script&lang=js&"
export * from "./SetupBusinessInfo.vue?vue&type=script&lang=js&"
import style0 from "./SetupBusinessInfo.vue?vue&type=style&index=0&id=465911b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465911b0",
  null
  
)

export default component.exports